import {
  border,
  color,
  rem,
  radius,
  token,
  spacing,
  text,
} from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';

export const styles = [
  css`
    :host {
      display: flex;
      flex-direction: column;
      position: relative;

      .small {
        font-size: ${rem(12)};
      }
    }

    :where(.select-content[variant='button']) {
      border: unset;
      border-radius: ${radius('medium')};
      box-shadow: ${token('elevation-shadow-raised')};

      ::slotted(a-select-option) {
        --option-checkmark-spacing: ${spacing(100)};
      }
    }

    :where(.select-content[variant='default']) {
      border-radius: ${radius('small')};
      box-shadow: 0 ${rem(2, 8)} hsl(240 3.8% 46.1% / 0.12);

      ::slotted(a-select-option:not(:last-child)) {
        border-block-end: ${border(1, 'grey', 300)};
      }
    }

    :where(.select-content) {
      border: ${border(1, 'grey', 300)};
      margin: unset;
      max-block-size: var(--auto-size-available-height);
      max-inline-size: var(--auto-size-available-width);
      overflow: hidden;
      overflow-y: auto;
      padding: unset;

      ::slotted(a-select-option) {
        inline-size: var(--auto-size-available-width);
      }
    }

    :where(.select-header[variant='button']) {
      background: ${color('beige', 100)};
      block-size: ${rem(38)};
      border-radius: ${radius('medium')};
      box-shadow: ${token('elevation-shadow-raised')};
      gap: ${spacing(75)};
      padding-inline-end: ${spacing(200)};
      padding-inline-start: ${spacing(200)};

      &:hover {
        background: ${color('grey', 300)};
      }

      :where(a-icon) {
        color: ${color('grey', 900)};
      }

      .container {
        max-inline-size: calc(100% - ${rem(12)} - var(--tm-spacing-space-75));
      }

      .container-value {
        inline-size: 100%;

        span {
          color: ${color('grey', 900)};
          /* @ include font size refuses to work here */
          font-size: ${rem(16)};
          inline-size: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          @include ${text('nav', 'medium', 'semi-bold')};
        }
      }
    }

    :where(.select-header[variant='default']) {
      background: ${color('white')};
      border: ${border(1, 'neutral', 600)};
      border-radius: ${radius('small')};
      gap: ${spacing(100)};
      padding: ${rem(12)};

      :where(a-icon) {
        color: ${color('blue', 600)};
      }
    }

    :where(.select-header) {
      align-items: center;
      cursor: pointer;
      display: flex;
      user-select: none;

      &:hover {
        border-color: ${color('blue', 600)};
      }

      :where(a-icon) {
        flex: 0 0 auto;
        margin-inline-start: auto;
      }
    }

    :where(.select-header.default-text) {
      color: ${color('neutral', 600)};
    }

    :host([disabled]) {
      :where(.select-header) {
        background: ${color('neutral', 100)};
        border: ${border(1, 'neutral', 300)};
        color: ${color('neutral', 400)};
        cursor: not-allowed;

        :where(a-icon) {
          color: ${color('neutral', 400)};
        }
      }

      :where(.container-value img) {
        filter: grayscale(100%);
        opacity: 0.5;
      }
    }

    :where(.container-value) {
      align-items: center;
      display: flex;
      gap: ${rem(20)};
      min-block-size: 1.5em;

      img {
        block-size: ${rem(55)};
        inline-size: ${rem(55)};
        object-fit: contain;

        &:not([src*='http']) {
          display: none;
        }
      }
    }

    :where(.container-value.input-focused) {
      color: ${color('grey', 300)};
    }

    :where(.container-value.input-focused img),
    :where(.container-value.input-focused a-icon) {
      opacity: 0.5;
    }

    :where(input) {
      background: transparent;
      border: unset;
      font-size: inherit;
      outline: none;
      position: absolute;
      transform: translateX(${rem(-3)});
    }

    :where(.container) {
      align-items: center;
      display: flex;
    }

    .hidden {
      visibility: hidden;
    }
  `,
];
